import { Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { RiDeleteBinLine, RiEdit2Line, RiPhoneFill } from "react-icons/ri";

type PhoneData = {
	id: string;
	numero: string;
	obs?: string;
	emp_cod: string;
}
type PhoneCadProps ={
	phone: PhoneData;
	setPhoneModal: (phone: PhoneData) => void;
	setIsNewTelClienteModal: (isOpen: boolean) => void;
	phones: PhoneData[];
	setPhones: (enderecos: PhoneData[]) => void;
}

const PhoneCadastro: React.FC<PhoneCadProps> = ({
	phone,
	setPhoneModal,
	setIsNewTelClienteModal,
	phones,
	setPhones,
}) => {
	function handleDeletePhone() {
		const phoneIndex = phones.findIndex(pho => pho.id === phone.id);
		phones.splice(phoneIndex, 1);
		setPhones([...phones]);
	}

	return (
		<Flex
			align="center"
			justify="space-between"
			bg="gray.40"
			borderColor="gray.100"
			borderWidth={1}
			borderRadius={8}
			py="2"
			px="4"
			_hover={{ boxShadow: 'lg' }}
		>
			<Flex
				w="100%"
				align="center"
				cursor="pointer"
				onClick={() => {
					setPhoneModal(phone);
					setIsNewTelClienteModal(true);
				}}
				>
				<Icon as={RiPhoneFill} fontSize="26" mr="4" color="gray.600" />
				<Box>
					<Text color="gray.600" fontSize="15">{phone.numero}</Text>
					<Text color="gray.500" fontSize="14">{phone.obs}</Text>
				</Box>
			</Flex>

			<Flex justify="flex-end">
				<Button
					p={0}
					size="sm"
					bg="transparent"
					_hover={{ bg: 'transparent' }}
					onClick={() => {
						setPhoneModal(phone);
						setIsNewTelClienteModal(true);
					}}
				>
					<Icon as={RiEdit2Line} fontSize="20" color="blue.100" />
				</Button>

				<Button
					p={0}
					size="sm"
					ml="1"
					bg="transparent"
					_hover={{ bg: 'transparent' }}
					onClick={handleDeletePhone}
				>
					<Icon as={RiDeleteBinLine} fontSize="20" color="red.500" />
				</Button>
			</Flex>
		</Flex>
	);
}

export default PhoneCadastro;
